module.exports = __webpack_public_path__ + "static/media/BOBBIE_BROWN.7af9e101.png";